import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import MenuPopover from './menu-popover/menu-popover.component';
import { RestaurantMenuOutlined } from '@mui/icons-material';
import CopyText from 'components/copy-text/copy-text.component';
import { useTranslation } from 'react-i18next';
import { TransformMenuResult } from 'api/ordering-service/ordering-service.types';

type MenusInfoCardProps = {
  isImported: boolean;
  data: TransformMenuResult;
};

const MenusInfoCard = ({ isImported, data }: MenusInfoCardProps) => {
  const { t } = useTranslation();

  return (
    <Card className="field-container" sx={{ mb: 2 }} elevation={4}>
      <CardHeader
        avatar={
          <Avatar
            src={data?.displayInfo[0]?.smallImage?.[0]}
            variant="circular"
            sx={{ width: 50, height: 50 }}
            data-testid="MenusInfoCard.Avatar"
          >
            <RestaurantMenuOutlined fontSize="large" />
          </Avatar>
        }
        title={
          <Stack direction="row" spacing={2} alignItems="flex-start">
            <Typography variant="h2">{data?.title}</Typography>
            {!!isImported && (
              <Chip
                label={t('forms.menusForm.menuCard.chip.label')}
                size="small"
                color="info"
              />
            )}
          </Stack>
        }
        action={<MenuPopover data={data} />}
      />
      <CardContent>
        <Stack direction="row" alignItems="center">
          <Typography mr={1} variant="h6">
            {t('forms.menusForm.menuCard.catalogId.label')}:
          </Typography>
          <CopyText>{data?.catalogId}</CopyText>
        </Stack>

        {!!isImported && (
          <Stack direction="row" alignItems="center" mt={1}>
            <Typography mr={1} variant="h6">
              {t('forms.menusForm.menuCard.externalId.label')}:
            </Typography>
            <CopyText>{data?.externalId}</CopyText>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default MenusInfoCard;
